import './search.css'
import { useLanguage } from '../../i18n/LanguageContext'

export default function SearchBar({ searchTerm, setSearchTerm }) {
  const { t } = useLanguage()

  return (
    <div className="search-wrapper">
      <div className="search-input-row">
        <input
          type="text"
          placeholder={t('search.placeholder')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
    </div>
  )
}
